/* Category arrivals and repeated menu links share one stable landing. */
(()=>{
 'use strict';
 const allowed=new Set(['cutting-tools','abrasives','fluids','workholding','machine-accessories','metrology','mro','coolant-systems']);
 let frame=0,retry=0,attempts=0,userMoved=false;
 const category=()=>new URLSearchParams(location.search).get('category');
 const isArrival=()=>allowed.has(category())&&location.hash==='#lc-directory';
 const cancelArrival=()=>{userMoved=true;cancelAnimationFrame(frame);clearTimeout(retry)};
 ['touchstart','wheel','keydown'].forEach(type=>addEventListener(type,cancelArrival,{passive:true}));
 function land(){
  if(userMoved||!isArrival())return;
  const directory=document.getElementById('lc-directory');if(!directory)return;
  // Two frames allow the closed menu/header and filter layout to settle.
  cancelAnimationFrame(frame);
  frame=requestAnimationFrame(()=>{frame=requestAnimationFrame(()=>{
   if(userMoved||!isArrival())return;
   directory.scrollIntoView({behavior:'instant',block:'start'});
   const heading=directory.querySelector('h2');
   if(heading){heading.setAttribute('tabindex','-1');heading.focus({preventScroll:true})}
  })});
 }
 function activate(){
  if(!isArrival())return;
  const chip=document.querySelector('[data-lc-chip="'+category()+'"]');
  if(!chip){if(++attempts<60)retry=setTimeout(activate,50);return}
  // Chips toggle on a second click. An arrival must always select, never toggle.
  if(chip.getAttribute('aria-pressed')!=='true')chip.click();
  land();
 }
 function init(){attempts=0;activate()}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 // Reserve the landing through font/image layout, but never pull back a visitor
 // who has already started scrolling or using the page.
 addEventListener('load',land,{once:true});
 document.fonts?.ready.then(land);
 addEventListener('pageshow',event=>{if(!event.persisted)land()});
 document.addEventListener('shopify:section:load',init);
 document.addEventListener('click',event=>{
  const link=event.target.closest?.('a[href]');
  if(!link||event.defaultPrevented||event.button>0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  const url=new URL(link.href,location.href);
  if(url.origin!==location.origin||url.pathname!==location.pathname||url.search!==location.search||url.hash!=='#lc-directory'||!allowed.has(url.searchParams.get('category')))return;
  event.preventDefault();
  document.dispatchEvent(new CustomEvent('site:close-menu'));
  if(location.hash!==url.hash)history.pushState(null,'',url.href);
  userMoved=false;init();
 },true);
})();
